import React from 'react';
import { Box, Container } from '@mui/material';

/**
 * AppPage — conteneur de page clair, harmonisé avec l'accueil.
 * Alternative au `PageLayout` (fond sombre glassmorphism) pour les écrans
 * repris dans le nouveau style : fond gris très clair, contenu centré.
 */
const AppPage: React.FC<{ children: React.ReactNode; maxWidth?: 'md' | 'lg' | 'xl' | false }> = ({
  children,
  maxWidth = 'xl',
}) => (
  <Box sx={{ bgcolor: '#f4f5f7', minHeight: 'calc(100vh - 60px)' }}>
    <Container maxWidth={maxWidth} sx={{ py: { xs: 3, md: 4 }, pb: { xs: 6, md: 8 } }}>
      {children}
    </Container>
  </Box>
);

export default AppPage;
